const childrenLoaded = require('@alexspirgel/children-loaded');
const extend = require('@alexspirgel/extend');
const transitionAuto = require('@alexspirgel/transition-auto');

class ComponentProgramFinder extends HTMLDivElement {

	static getFormValues(element) {
		const formFieldNamesAndValues = {};
		const formData = new FormData(element);
		for (const entry of formData.entries()) {
			const name = entry[0];
			const value = entry[1];
			formFieldNamesAndValues[name] = value;
		}
		return formFieldNamesAndValues;
	}

	static setFormValues(formElement, namesValues) {
		for (const name in namesValues) {
			const value = namesValues[name];
			const formFieldElement = formElement.querySelector(`[name="${name}"]`);
			if (formFieldElement) {
				if (formFieldElement.tagName == 'SELECT') {
					let foundOption = null;
					const options = formFieldElement.querySelectorAll('option');
					for (const option of options) {
						const optionValue = option.getAttribute('value');
						if (value === optionValue) {
							foundOption = true;
							break;
						}
					}
					if (foundOption) {
						formFieldElement.value = value;
					}
				}
				if (formFieldElement.getAttribute('type') == 'checkbox') {
					formFieldElement.checked = true;
				}
				else {
					formFieldElement.value = value;
				}
			}
		}
	}

	static getQueryStrings() {
		const queryStrings = {};
		const urlSearchParams = new URLSearchParams(window.location.search);
		for (const urlSearchParam of urlSearchParams) {
			const key = urlSearchParam[0];
			const value = urlSearchParam[1];
			if (typeof key !== undefined) {
				queryStrings[key] = '';
				if (typeof value !== undefined) {
					queryStrings[key] = value;
				}
			}
		}
		return queryStrings;
	}

	static setQueryStrings(queryStrings) {
		const searchParams = new URLSearchParams(window.location.search);

		let normalizedQueryStrings = {};
		for (const key in queryStrings) {
			const value = queryStrings[key];
			if (key.startsWith('degree_level')) {
				if (typeof normalizedQueryStrings['degree-level'] === 'undefined') {
					normalizedQueryStrings['degree-level'] = [value];
				}
				else if (!normalizedQueryStrings['degree-level'].includes(value)) {
					normalizedQueryStrings['degree-level'].push(value);
				}
			}
			else if (key.startsWith('school_college')) {
				if (typeof normalizedQueryStrings['school-college'] === 'undefined') {
					normalizedQueryStrings['school-college'] = [value];
				}
				else if (!normalizedQueryStrings['school-college'].includes(value)) {
					normalizedQueryStrings['school-college'].push(value);
				}
			}
			else if (key.startsWith('career_interest')) {
				if (typeof normalizedQueryStrings['career-interest'] === 'undefined') {
					normalizedQueryStrings['career-interest'] = [value];
				}
				else if (!normalizedQueryStrings['career-interest'].includes(value)) {
					normalizedQueryStrings['career-interest'].push(value);
				}
			}
			else if (key.startsWith('visa_eligible')) {
				if (typeof normalizedQueryStrings['visa-eligible'] === 'undefined') {
					normalizedQueryStrings['visa-eligible'] = [value];
				}
				else if (!normalizedQueryStrings['visa-eligible'].includes(value)) {
					normalizedQueryStrings['visa-eligible'].push(value);
				}
			}
			else {
				normalizedQueryStrings[key] = value;
			}
		}
		if (Array.isArray(normalizedQueryStrings['degree-level'])) {
			normalizedQueryStrings['degree-level'] = normalizedQueryStrings['degree-level'].toString();
		}
		if (Array.isArray(normalizedQueryStrings['school-college'])) {
			normalizedQueryStrings['school-college'] = normalizedQueryStrings['school-college'].toString();
		}
		if (Array.isArray(normalizedQueryStrings['career-interest'])) {
			normalizedQueryStrings['career-interest'] = normalizedQueryStrings['career-interest'].toString();
		}
		if (Array.isArray(normalizedQueryStrings['visa-eligible'])) {
			normalizedQueryStrings['visa-eligible'] = normalizedQueryStrings['visa-eligible'].toString();
		}
		queryStrings = normalizedQueryStrings;

		const existingQueryStrings = this.getQueryStrings();
		for (const existingKey in existingQueryStrings) {
			if (!(existingKey in queryStrings)) {
				searchParams.delete(existingKey);
			}
		}

		for (const key in queryStrings) {
			const value = queryStrings[key];
			searchParams.set(key, value);
		}

		if (typeof queryStrings['search'] === 'undefined' || queryStrings['search'] === '') {
			searchParams.delete('search');
		}

		const newURL = new URL(window.location.href);
		newURL.search = searchParams.toString();
		window.history.replaceState({path: newURL.href}, '', newURL.href);
	}

	static uncheckAllCheckboxes(formElement) {
		const checkboxes = formElement.querySelectorAll('input[type="checkbox"]');
		for (const checkbox of checkboxes) {
			checkbox.checked = false;
		}
	}

	static delay = (ms) => {
		return new Promise((res) => {
			setTimeout(res, ms)
		});
	}

	static moveChildren(from, to) {
		while (from.childNodes.length > 0) {
			to.appendChild(from.childNodes[0]);
		}
	}

	constructor() {
		super();
		this.initializeAjaxListener();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		// Prevents overlay loading in admin edit form page
		if (document.querySelector('body.gin--edit-form.user-logged-in')) {
			Array.from(document.querySelectorAll('a.component-program-finder__program')).forEach(
				function (item) {
					item.replaceWith(item.cloneNode(true));
				}
			);
			return;
		}
		this.dummyFormElements = {
			'search': this.querySelector('.js-dummy-search-form'),
			'single-checkboxes': this.querySelector('.js-dummy-single-checkbox-form'),
			'checkboxes': {
				'degree-level': this.querySelector('.js-dummy-checkbox-form[data-name="degree-level"]'),
				'school-college': this.querySelector('.js-dummy-checkbox-form[data-name="school-college"]'),
				'career-interest': this.querySelector('.js-dummy-checkbox-form[data-name="career-interest"]'),
			},
		};
		this.facetListElement = this.querySelector('.js-facet-list');

		// apply query strings
		let queryStrings = this.constructor.getQueryStrings();
		let formQueryStrings = false;
		// console.log(queryStrings);
		for (const key in queryStrings) {
			const value = queryStrings[key];
			if (key === 'search') {
				// this.realFormElement.querySelector('input[name="search"]').value = value;
				formQueryStrings = true;
			}
			if (key === 'degree-level') {
				const values = value.split(',');
				formQueryStrings = true;
				for (const singleValue of values) {
					let input = this.realFormElement.querySelector(`input[name="degree_level[${singleValue}]"]`);
					if (input) {
						input.checked = true;
					}
				}
			}
			else if (key === 'school-college') {
				const values = value.split(',');
				formQueryStrings = true;
				for (const singleValue of values) {
					let input = this.realFormElement.querySelector(`input[name="school_college[${singleValue}]"]`);
					if (input) {
						input.checked = true;
					}
				}
			}
			else if (key === 'career-interest') {
				const values = value.split(',');
				formQueryStrings = true;
				for (const singleValue of values) {
					let input = this.realFormElement.querySelector(`input[name="career_interest[${singleValue}]"]`);
					if (input) {
						input.checked = true;
					}
				}
			}
			else if (key === 'visa-eligible') {
				const values = value.split(',');
				formQueryStrings = true;
				for (const singleValue of values) {
					if (singleValue == 1 || singleValue == '1') {}
					let input = this.realFormElement.querySelector(`input[name="visa_eligible"]`);
					if (input) {
						input.checked = true;
					}
				}
			}
		}

		// attach dummy form submit handlers
		this.dummyFormElements['search'].addEventListener('submit', this.dummyFormSubmitHandler);
		for (const dummyCheckboxGroup in this.dummyFormElements['checkboxes']) {
			const dummyCheckboxFormElement = this.dummyFormElements['checkboxes'][dummyCheckboxGroup];
			dummyCheckboxFormElement.addEventListener('submit', this.dummyFormSubmitHandler);
		}

		// attach dummy form group toggle click handlers
		for (const dummyFormGroupToggleElement of this.querySelectorAll('.js-dummy-filter-checkbox-group-toggle')) {
			dummyFormGroupToggleElement.addEventListener('click', this.dummyFormGroupToggleClickHandler);
		}

		// attach facet clear button click handler
		this.facetClearElement = this.querySelector('.js-facet-clear');
		if (this.facetClearElement) {
			this.facetClearElement.addEventListener('click', (event) => {
				this.dummyFormElements['search'].querySelector('input').value = '';
				for (const facetElement of this.allFacetElements) {
					this.removeFacet(facetElement.getAttribute('data-name'), false);
				}
				this.dummyFormSubmitHandler();
			});
		}

		// grid options
		this.displayOptionGridButtonElement = this.querySelector('.js-display-option-grid');
		if (this.displayOptionGridButtonElement) {
			this.displayOptionGridButtonElement.addEventListener('click', () => {
				if (this.displayOptionValue != 'grid') {
					this.setAttribute('data-display-option', 'grid');
				}
			});
		}
		this.displayOptionListButtonElement = this.querySelector('.js-display-option-list');
		if (this.displayOptionListButtonElement) {
			this.displayOptionListButtonElement.addEventListener('click', () => {
				if (this.displayOptionValue != 'list') {
					this.setAttribute('data-display-option', 'list');
				}
			});
		}
		if (this.isMobile()) {
			this.displayOptionListButtonElement.click();
		}

		// mobile additional filters toggle
		this.additionalFiltersToggleElement = this.querySelector('.js-additional-filters-toggle');
		this.additionalFiltersElement = this.querySelector('.js-additional-filters');
		this.additionalFiltersToggleElement.addEventListener('click', () => {
			if (this.additionalFiltersToggleElement.getAttribute('data-state') == 'open') {
				this.additionalFiltersToggleElement.setAttribute('data-state', 'close');
				this.additionalFiltersElement.setAttribute('data-state', 'close');
			}
			else {
				this.additionalFiltersToggleElement.setAttribute('data-state', 'open');
				this.additionalFiltersElement.setAttribute('data-state', 'open');
			}
		});

		// Checkbox mobile repositioning
		this.repositionCheckboxes();
		window.addEventListener('resize', () => {
			this.repositionCheckboxes();
		});

		this.createDummyCheckboxes();
		this.copyRealValuesToDummy();
		this.attachDummyCheckboxEventListeners();
		this.updateFacets(false);
		this.updateFakeResultsSummary();
		if (formQueryStrings) {
			document.addEventListener('DOMContentLoaded', () => {
				this.submitRealForm(false);
			});
		}
		this.repositionCheckboxes();
	}

	isMobile() {
		let mediaQueryMobile = window.matchMedia('(max-width: 48rem)');
		if (mediaQueryMobile.matches) {
			return true;
		}
		else {
			return false;
		}
	}

	initializeAjaxListener() {
		(($, Drupal, once) => {
			'use strict';
			Drupal.behaviors.programFinder = {
				attach: (context, settings) => {
					if (context
					&& typeof context === 'object'
					&& typeof context.classList !== 'undefined'
					&& context.classList.contains('views-ajax-wrapper')) {
						const parentProgramFinder = context.closest('.component-program-finder');
						if (parentProgramFinder && parentProgramFinder === this) {
							this.onAjax();
						}
					}
				}
			};
		})(jQuery, Drupal, once);
	}

	onAjax() {
		this.updateFakeResultsSummary();
		if (typeof this._savedScrollY === 'number') {
			const savedY = this._savedScrollY;
			this._savedScrollY = undefined;
			requestAnimationFrame(() => {
				window.scrollTo({ top: savedY, behavior: 'instant' });
			});
		}
	}

	get realFormElement() {
		return this.querySelector('.views-exposed-form');
	}

	get realFormSubmitElement() {
		return this.realFormElement.querySelector('input[type="submit"]');
	}

	createDummyCheckboxes() {
		const realFilters = {
			'degree-level': this.querySelectorAll('.views-exposed-form fieldset[data-drupal-selector="edit-degree-level"] input'),
			'school-college': this.querySelectorAll('.views-exposed-form fieldset[data-drupal-selector="edit-school-college"] input'),
			'career-interest': this.querySelectorAll('.views-exposed-form fieldset[data-drupal-selector="edit-career-interest"] input')
		};
		for (const filterGroup in realFilters) {
			const dummyFilterForm = this.dummyFormElements['checkboxes'][filterGroup];
			for (const realFilter of realFilters[filterGroup]) {
				// wrapper
				const dummyFilterWrapper = document.createElement('div');
				// dummyFilterWrapper.classList.add(`component-program-finder__dummy-filters-${filterGroup}-input-wrapper`);
				dummyFilterWrapper.classList.add(`component-program-finder__dummy-filters-input-wrapper`);
				dummyFilterForm.appendChild(dummyFilterWrapper);
				// input
				const dummyFilter = document.createElement('input');
				// dummyFilter.classList.add(`component-program-finder__dummy-filters-${filterGroup}-input`);
				dummyFilter.classList.add(`component-program-finder__dummy-filters-input`);
				dummyFilter.setAttribute('type', 'checkbox');
				dummyFilter.setAttribute('id', `dummy-${realFilter.id}`);
				dummyFilter.setAttribute('value', realFilter.value);
				dummyFilter.setAttribute('name', realFilter.name);
				dummyFilterWrapper.appendChild(dummyFilter);
				// label
				const realFilterLabel = realFilter.nextElementSibling;
				const dummyFilterLabel = document.createElement('label');
				dummyFilterLabel.textContent = realFilterLabel.textContent;
				// dummyFilterLabel.classList.add(`component-program-finder__dummy-filters-${filterGroup}-label`);
				dummyFilterLabel.classList.add(`component-program-finder__dummy-filters-label`);
				dummyFilterLabel.setAttribute('for', dummyFilter.id);
				dummyFilterWrapper.appendChild(dummyFilterLabel);
			}
		}
	}

	copyRealValuesToDummy() {
		const realValues = this.constructor.getFormValues(this.realFormElement);
		this.constructor.setFormValues(this.dummyFormElements['search'], realValues);

		this.constructor.uncheckAllCheckboxes(this.dummyFormElements['single-checkboxes']);
		this.constructor.setFormValues(this.dummyFormElements['single-checkboxes'], realValues);

		for (const dummyCheckboxGroup in this.dummyFormElements['checkboxes']) {
			const dummyCheckboxFormElement = this.dummyFormElements['checkboxes'][dummyCheckboxGroup];
			this.constructor.uncheckAllCheckboxes(dummyCheckboxFormElement);
			this.constructor.setFormValues(dummyCheckboxFormElement, realValues);
		}
	}

	getDummyFormValues() {
		const dummyValues = {};

		extend(dummyValues, this.constructor.getFormValues(this.dummyFormElements['search']));

		const singleCheckboxDummyFormValues = this.constructor.getFormValues(this.dummyFormElements['single-checkboxes']);
		extend(dummyValues, singleCheckboxDummyFormValues);

		for (const checkboxGroup in this.dummyFormElements['checkboxes']) {
			const dummyCheckboxFormElement = this.dummyFormElements['checkboxes'][checkboxGroup];
			const formValues = this.constructor.getFormValues(dummyCheckboxFormElement);
			extend(dummyValues, formValues);
		}

		return dummyValues;
	}

	copyDummyValuesToReal() {
		const dummyValues = this.getDummyFormValues();
		this.constructor.uncheckAllCheckboxes(this.realFormElement);
		this.constructor.setFormValues(this.realFormElement, dummyValues);
	}

	attachDummyCheckboxEventListeners () {
		this.dummyFormElements['single-checkboxes'].addEventListener('change', this.dummyCheckboxChangeHandler);

		for (const dummyCheckboxGroup in this.dummyFormElements['checkboxes']) {
			const dummyCheckboxFormElement = this.dummyFormElements['checkboxes'][dummyCheckboxGroup];
			dummyCheckboxFormElement.addEventListener('change', this.dummyCheckboxChangeHandler);
		}
	}

	get allFacetElements() {
		return this.facetListElement.querySelectorAll('.js-facet-item');
	}

	addFacet(name, submitForm = true) {
		const inputElement = this.querySelector(`.js-dummy-filters [name="${name}"]`);
		if (inputElement) {
			const labelElement = inputElement.nextElementSibling;
			if (labelElement) {
				const facetElement = document.createElement('button');
				facetElement.classList.add('component-program-finder__facet');
				facetElement.classList.add('js-facet-item');
				facetElement.setAttribute('data-name', name);
				facetElement.textContent = labelElement.textContent;
				facetElement.innerHTML += `<svg class="icon-facet-x" version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" width="11" height="11"><path fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="square" stroke-linejoin="round" stroke-width="1.3" d="m1.2 1.1l8.5 8.4m0-8.4l-8.5 8.4"/></svg>`;
				this.facetListElement.insertBefore(facetElement, this.facetClearElement);
				facetElement.addEventListener('click', () => {
					this.removeFacet(name);
				});
				if (submitForm) {
					this.dummyFormSubmitHandler();
				}
			}
		}
	}

	removeFacet(name, submitForm = true) {
		const inputElement = this.querySelector(`.js-dummy-filters [name="${name}"]`);
		const matchingFacets = this.facetListElement.querySelectorAll(`[data-name="${name}"]`);
		for (const matchingFacet of matchingFacets) {
			inputElement.checked = false;
			matchingFacet.remove();
			if (submitForm) {
				this.dummyFormSubmitHandler();
			}
		}
	}

	updateFacets(submitForm = true) {
		const dummyFormValues = this.getDummyFormValues();
		delete dummyFormValues['search'];
		let anythingChangedFlag = false;
		// remove old facets
		for (const activeFacetElement of this.allFacetElements) {
			const facetName = activeFacetElement.getAttribute('data-name');
			if (!(facetName in dummyFormValues)) {
				this.removeFacet(facetName, false);
				anythingChangedFlag = true;
			}
		}
		// add new facets
		for (const dummyFormValueName in dummyFormValues) {
			const existingFacetsWithName = this.facetListElement.querySelectorAll(`[data-name="${dummyFormValueName}"]`);
			// facet doesn't exist
			if (existingFacetsWithName.length < 1) {
				this.addFacet(dummyFormValueName, false);
				anythingChangedFlag = true;
			}
			// remove extra facets that shouldn't be there, leaving 1 correct facet
			else if (existingFacetsWithName.length > 1) {
				for (let i = 0; i < existingFacetsWithName.length; i++) {
					if (i > 0) {
						existingFacetsWithName[i].remove();
					}
				}
			}
		}
		if (anythingChangedFlag && submitForm) {
			this.dummyFormSubmitHandler();
		}
	}

	dummyFormSubmitHandler = (event) => {
		if (event) {
			event.preventDefault();
		}
		this.copyDummyValuesToReal();
		this.submitRealForm();
		return false;
	}

	dummyFormGroupToggleClickHandler = (event) => {
		let toggleButtonElement = event.target;
		if (!toggleButtonElement.getAttribute('data-name')) {
			toggleButtonElement = toggleButtonElement.closest('button[data-name]');
		}
		const name = toggleButtonElement.getAttribute('data-name');
		const checkboxFormElement = this.querySelector(`.js-dummy-checkbox-form[data-name="${name}"]`);
		const state = checkboxFormElement.getAttribute('data-state');
		if (state != 'open') {
			this.openDummyFormGroup(name);
		}
		else {
			this.closeDummyFormGroup(name);
		}
	}

get currentlyOpenFromGroup() {
		return this.querySelector(`.js-dummy-checkbox-form[data-state="open"]`);
	}

	async openDummyFormGroup(name) {
		const toggleElement = this.querySelector(`.js-dummy-filter-checkbox-group-toggle[data-name="${name}"]`);
		const checkboxFormElement = this.querySelector(`.js-dummy-checkbox-form[data-name="${name}"]`);
		const state = checkboxFormElement.getAttribute('data-state');
		if (state != 'open') {
			const currentlyOpenFromGroup = this.currentlyOpenFromGroup;
			if (currentlyOpenFromGroup) {
				const currentlyOpenName = currentlyOpenFromGroup.getAttribute('data-name');
				this.closeDummyFormGroup(currentlyOpenName);
				await this.constructor.delay(250);
			}
			toggleElement.setAttribute('data-state', 'open');
			toggleElement.setAttribute('aria-expanded', 'true');
			checkboxFormElement.setAttribute('data-state', 'open');
			checkboxFormElement.setAttribute('data-transition-state', 'active');
			transitionAuto({
				element: checkboxFormElement.parentElement,
				innerElement: checkboxFormElement,
				property: 'height',
				value: 'auto',
				onComplete: () => {checkboxFormElement.setAttribute('data-transition-state', 'complete')}
			});
		}
	}

	closeDummyFormGroup(name) {
		const toggleElement = this.querySelector(`.js-dummy-filter-checkbox-group-toggle[data-name="${name}"]`);
		const checkboxFormElement = this.querySelector(`.js-dummy-checkbox-form[data-name="${name}"]`);
		const state = checkboxFormElement.getAttribute('data-state');
		if (state != 'close') {
			toggleElement.setAttribute('data-state', 'close');
			toggleElement.setAttribute('aria-expanded', 'false');
			checkboxFormElement.setAttribute('data-state', 'close');
			checkboxFormElement.setAttribute('data-transition-state', 'active');
			transitionAuto({
				element: checkboxFormElement.parentElement,
				innerElement: checkboxFormElement,
				property: 'height',
				value: '0px',
				onComplete: () => {checkboxFormElement.setAttribute('data-transition-state', 'complete')}
			});
		}
	}

	closeAllDummyFormGroup() {
		const checkboxFormElements = this.querySelectorAll(`.js-dummy-checkbox-form[data-name]`);
		for (const checkboxFormElement of checkboxFormElements) {
			const name = checkboxFormElement.getAttribute('data-name');
			this.closeDummyFormGroup(name);
		}
	}

	dummyCheckboxChangeHandler = (event) => {
		this.dummyFormSubmitHandler();
		this.updateFacets();
	}

	get displayOptionValue() {
		return this.getAttribute('data-display-option');
	}

	get realViewsHeader() {
		return this.querySelector('.views-element-container .views-header');
	}

	get realViewsEmpty() {
		return this.querySelector('.views-element-container .views-empty');
	}

	updateFakeResultsSummary() {
		const dummyResultsSummary = this.querySelector('.js-dummy-results-summary');
		if (dummyResultsSummary) {
			let resultsSummaryText = '';
			if (this.realViewsHeader) {
				resultsSummaryText = this.realViewsHeader.textContent;
			}
			else if (this.realViewsEmpty) {
				resultsSummaryText = this.realViewsEmpty.textContent;
			}
			dummyResultsSummary.textContent = resultsSummaryText;
		}
	}

	submitRealForm(updateQueryStrings = true) {
		if (updateQueryStrings) {
			const submittedValues = this.constructor.getFormValues(this.realFormElement);
			this.constructor.setQueryStrings(submittedValues);
			// console.log('submittedValues', submittedValues);
		}
		this._savedScrollY = window.scrollY;
		const realFormSubmitElement = this.realFormSubmitElement;
		if (realFormSubmitElement) {
			realFormSubmitElement.click();
		}
	}

	get mobileCheckboxContainerElements() {
		return this.querySelectorAll('.js-mobile-program-finder-form-wrapper');
	}
	get desktopCheckboxContainerElements() {
		return this.querySelectorAll('.js-program-finder-form-wrapper');
	}
	// Should return 'mobile' or 'desktop'
	get whereAreCheckboxes() {
		const mobileContainer = this.mobileCheckboxContainerElements[0];
		if (mobileContainer && mobileContainer.hasChildNodes()) {
			return 'mobile';
		}
		const desktopContainer = this.desktopCheckboxContainerElements[0];
		if (desktopContainer && desktopContainer.hasChildNodes()) {
			return 'desktop';
		}
		return null;
	}

	repositionCheckboxes() {
		if (this.isMobile()) {
			this.moveCheckboxesToMobile();
		}
		else {
			this.moveCheckboxesToDesktop();
		}
	}

	moveCheckboxesToMobile() {
		if (this.whereAreCheckboxes !== 'mobile') {
			this.closeAllDummyFormGroup();
			for (let i = 0; i < this.desktopCheckboxContainerElements.length; i++) {
				this.constructor.moveChildren(this.desktopCheckboxContainerElements[i], this.mobileCheckboxContainerElements[i]);
			}
		}
	}

	moveCheckboxesToDesktop() {
		if (this.whereAreCheckboxes !== 'desktop') {
			this.closeAllDummyFormGroup();
			for (let i = 0; i < this.mobileCheckboxContainerElements.length; i++) {
				this.constructor.moveChildren(this.mobileCheckboxContainerElements[i], this.desktopCheckboxContainerElements[i]);
			}
		}
	}

}

customElements.define('component-program-finder', ComponentProgramFinder, {extends: 'div'});